import {FAILURE, PENDING, RESET, SUCCESS} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS, RESET: 'RESET'}
const InitialState = {
  data: {},
  errors: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case RESET:
      return {...InitialState}
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: null,
        data: action.payload.data || {},
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const usePostCalendarChildViewReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default usePostCalendarChildViewReducer
export {ActionTypes, InitialState, Reducer}
